import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Order Cancelled")
const _hoisted_2 = { class: "flex-1 t-center" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "mt-20"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_DialogTemplate = _resolveComponent("DialogTemplate")

  return (_openBlock(), _createBlock(_component_DialogTemplate, null, _createSlots({
    default: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_ctx.done)
          ? (_openBlock(), _createBlock("p", _hoisted_3, [
              _createVNode(_component_Icon, {
                name: "check",
                class: "bg-success mb-20",
                style: {"font-size":"40px","color":"white","border-radius":"20px"}
              })
            ]))
          : (_openBlock(), _createBlock("p", _hoisted_4, "Cancel the order"))
      ])
    ]),
    _: 2
  }, [
    (_ctx.done)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _createVNode(_component_t, { path: "symbol_58" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ])
        }
      : {
          name: "title",
          fn: _withCtx(() => [
            _createVNode(_component_t, { path: "symbol_53" }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel order")
              ]),
              _: 1
            })
          ])
        },
    (_ctx.done)
      ? {
          name: "controls",
          fn: _withCtx(() => [
            _hoisted_5
          ])
        }
      : {
          name: "confirm",
          fn: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "flex-1 primary",
              onClick: _ctx.submit,
              progress: _ctx.progress
            }, {
              default: _withCtx(() => [
                _createVNode(_component_t, {
                  path: "symbol_57",
                  custom: ""
                }, {
                  default: _withCtx(({td}) => [
                    _createTextVNode(_toDisplayString(td || 'Submit'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick", "progress"])
          ])
        }
  ]), 1024))
}